<template>
  <v-layout row justify-center>
    <v-card>
      <img :src="logo_cl" alt="profile" width="350">
      <v-card-title class="headline white--text" style="position: absolute; top: 0">Profile Info</v-card-title>
      <v-card-text>
        <table>
          <tr>
            <td>Account Name</td>
            <td>:</td>
            <td>{{ username }}</td>
          </tr>
          <tr>
            <td>Username</td>
            <td>:</td>
            <td>{{ receiver }} </td>
          </tr>
        </table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" flat @click="close()">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Profile',
  computed: {
    ...mapState([
      'username',
      'logo_cl',
      'receiver'
    ])
  },
  methods: {
    close () {
      this.$emit('closePop', null)
    }
  }
}
</script>

<style scoped>
.primary--text, .green--text {
  color: rgb(77, 189, 153)!important;
}
.green {
  background: rgb(77, 189, 153)!important;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  border: 1px solid #ddd;
  font-size: 12px;
}
th, td {
  text-align: left;
  padding: 5px;
}
</style>
